import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./StaffDashboard.css";

const StaffDashboard = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <div className="staff-dashboard">

      {/* HEADER */}
      <div className="staff-header">
        <h2>Staff Operations Dashboard</h2>
        <p>
          Welcome back, <b>{user.name}</b> 👋
        </p>
        <small>Manage your assigned leads, visits, and field activities</small>
      </div>

      {/* GRID */}
      <div className="staff-grid">

        {/* LEADS */}
        <div
          className="staff-card blue"
          onClick={() => navigate("/staff/leads")}
        >
          <h3>Assigned Leads</h3>
          <p>View, update & manage your active sales leads</p>
        </div>

        {/* ACTIVITY */}
        <div
          className="staff-card green"
          onClick={() => navigate("/staff/leads")}
        >
          <h3>Lead Activity Timeline</h3>
          <p>Track calls, updates, and interaction history</p>
        </div>

        {/* VISITS */}
        <div
          className="staff-card orange"
          onClick={() => navigate("/staff/leads")}
        >
          <h3>Field Visit Proof</h3>
          <p>Upload geo-tagged images & visit confirmation</p>
        </div>

      </div>

    </div>
  );
};

export default StaffDashboard;